module.exports = __webpack_public_path__ + "static/selected-language-screen-7626a71639cb2b2cbbbb0a03898d27bc.png";